module.exports = __webpack_public_path__ + "images/8197dcc81679c70077ff077036a699ab.png";